"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Accelerator: function() {
        return Accelerator;
    },
    default: function() {
        return _default;
    }
});
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
var Accelerator = /*#__PURE__*/ function() {
    "use strict";
    function Accelerator() {
        _classCallCheck(this, Accelerator);
        this.subscribers = {};
        this.subscribers = Object.assign({}, {});
    }
    var _proto = Accelerator.prototype;
    _proto.subscribe = function subscribe(event, callback) {
        if (!Array.isArray(this.subscribers[event])) {
            this.subscribers[event] = [];
        }
        this.subscribers[event].push(callback);
    };
    _proto.publish = function publish(event, data) {
        if (!Array.isArray(this.subscribers[event])) {
            return;
        }
        this.subscribers[event].forEach(function(callback) {
            callback(data);
        });
    };
    /**
     * Check if there are any subscribers.
     */ _proto.hasSubscribers = function hasSubscribers() {
        return Object.keys(this.subscribers).length > 0;
    };
    _proto.hasSubscriber = function hasSubscriber(key) {
        return Object.keys(this.subscribers).includes(key);
    };
    /**
     * Get a list of all subscribers
     */ _proto.getSubscribers = function getSubscribers() {
        return Object.keys(this.subscribers);
    };
    _proto.getSubscriberCount = function getSubscriberCount() {
        return Object.keys(this.subscribers).length;
    };
    /**
     * Removes all subscribers from this PubSub.
     */ _proto.removeAllSubscribers = function removeAllSubscribers() {
        this.subscribers = {};
    };
    return Accelerator;
}();
var _default = Accelerator;
